import React from 'react';

import { Container, BoxImage } from './styles';

const Header = () => (
  <Container>
    <BoxImage>
      <img src="/corporate/images/logo-netviajes.svg" alt="logo-rappi" />
    </BoxImage>
  </Container>
);

export default Header;
